import { _delete, _get, _post, _put } from "lib/rest";

export const getUser = async () => await _get("/accounts/");

export const getToken = async (data: {
  username: string;
  email: string;
  password: string;
}) => await _post(`/accounts/login/`, data);

export const getTokenGoogle = async (data: {
  access_token?: string;
  code?: string;
  id_token?: string;
}) => await _post("/accounts/login/google/", data);

export const createUser = async (data: {
  username: string;
  email: string;
  password1: string;
  password2: string;
  agreement: boolean;
  marketing: boolean;
}) => await _post(`/accounts/registration/`, data);

export const createGoogleUser = async (data: {
  username: string;
  email: string;
  password1: string;
  password2: string;
  agreement: boolean;
  marketing: boolean;
}) =>
  await _put(`/accounts/`, {
    username: data.email.split("@")[0],
    email: data.email,
    agreement: data.agreement,
    marketing: data.marketing,
  });

//비밀번호 변경
export const changePassword = async (data: {
  old_password: string;
  new_password1: string;
  new_password2: string;
}) => _post("/accounts/password/change/", data);

export const getPlan = async () => await _get("/accounts/plan/");

//user api
export const getAPI = async () => await _get("/accounts/developer/");
export const updateAPI = async () => await _post("/accounts/developer/");
export const deleteAPI = async () => await _delete("/accounts/developer/");
